import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import fusionSupporterBackendApp from './reducers/index';
import persistState from 'redux-localstorage';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

const enhancer = compose(
    applyMiddleware(thunkMiddleware),
    applyMiddleware(sagaMiddleware),
    persistState()
);

const store = createStore(fusionSupporterBackendApp, enhancer);
sagaMiddleware.run(rootSaga);
export {store};
